import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable,of} from "rxjs";
import {environment} from "@environments/environment";
import {Result} from "@domain/common/http/result";
import {first} from "rxjs/operators";
import {PourcentageDomaine,ReglesAttributionConf} from "@domain/admin/frais/indemnites/indemnites-parametres";
import {tap} from "rxjs/operators";

/**
 * Service de gestion des paramètres IJ
 */
@Injectable()
export class IndemnitesParametresService {
    //Cache local de la réponse des pourcentages (évite de rappeler un endpoint backend coûteux à chaque navigation)
    private static cacheListeIndemnite: Result = null;

    //Timestamp de mise en cache
    private static cacheListeIndemniteAt: number = 0;

    //Durée de vie du cache en ms
    private static readonly CACHE_TTL_MS: number = 5 * 60 * 1000;

    /**
     * Constructeur
     *
     * @param http Service HTTP
     */
    constructor(private http: HttpClient) {}

    /**
     * Chargement de la liste des indemnités
     */
    loadListePourcentagesDomaine(): Observable<Result> {
        const now = Date.now();
        const hasCacheValide = !!IndemnitesParametresService.cacheListeIndemnite
            && (now - IndemnitesParametresService.cacheListeIndemniteAt) < IndemnitesParametresService.CACHE_TTL_MS;

        //Retour immédiat depuis le cache si disponible
        if (hasCacheValide) {
            return of(IndemnitesParametresService.cacheListeIndemnite).pipe(first());
        }

        return this.http.post<Result>(`${environment.baseUrl}/controller/IJ/listePourcentagesDomaine`,null).pipe(
            tap((result: Result) => {
                IndemnitesParametresService.cacheListeIndemnite = result;
                IndemnitesParametresService.cacheListeIndemniteAt = Date.now();
            }),
            first()
        );
    }

    /**
     * Chargement de la configuration des règles d'attribution
     */
    loadReglesAttributionConf(): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/RegleAttribution/loadConf`,null).pipe(first());
    }

    /**
     * Sauvegarde des pourcentages par domaine
     *
     * @param listePourcentages liste des pourcentages à sauvegarder
     */
    savePourcentages(listePourcentages: PourcentageDomaine[]): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/IJ/savePourcentage`,listePourcentages).pipe(
            tap(() => {
                //Invalidation du cache pour forcer un rechargement au prochain accès
                IndemnitesParametresService.cacheListeIndemnite = null;
                IndemnitesParametresService.cacheListeIndemniteAt = 0;
            }),
            first()
        );
    }

    /**
     * Sauvegarde de la configuration des délais forfaitaires
     *
     * @param reglesConf configuration des délais à sauvegarder
     */
    saveReglesAttributionConf(reglesConf: ReglesAttributionConf): Observable<Result> {
        return this.http.put<Result>(`${environment.baseUrl}/controller/RegleAttribution/saveReglesAttributionConf`,reglesConf).pipe(first());
    }
}
